import { render } from "./notice.vue?vue&type=template&id=298534e8&ts=true"
import script from "./notice.vue?vue&type=script&lang=ts&setup=true"
export * from "./notice.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/notice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "298534e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('298534e8', __exports__)) {
    console.log('reload')
    api.reload('298534e8', __exports__)
  }
  
  module.hot.accept("./notice.vue?vue&type=template&id=298534e8&ts=true", () => {
    console.log('re-render')
    api.rerender('298534e8', render)
  })

}


export default __exports__